import AODLayout from "../components/AdmissionsOfficeDatabase/AODLayout";

const AdmissionsOfficeDatabasePage = () => {
  return (
    <>
      <div id="modal-root"></div>
      <AODLayout />
    </>
  );
};

export default AdmissionsOfficeDatabasePage;
